import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Input,
  FormText,
} from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";

const SignIn = (props) => {
  const { setLoggedIn, closeModal } = props;
  const [name, setname] = useState("");
  const [pass, setpass] = useState("");
  const history = useHistory();
  const verify = (e) => {
    e.preventDefault();
    axios({
      method: "POST",
      url: "https://aqueous-plains-06808.herokuapp.com/api/v1/users/login",

      headers: {
        "content-type": "application/json",
      },
      data: {
        email: name,
        password: pass,
      },
    })
      .then((response) => {
        if (response.data.access_token) {
          toast.success("logged in successfully..", { position: "top-left" });
          localStorage.setItem("token", response.data.access_token);
          localStorage.setItem("email", name);
          console.log("logged in");
          setLoggedIn(true);
          history.push("./myProfile");
          closeModal(true);
        } else {
          history.push("./");
        }
      })
      .catch((error) => {
        console.error(error.response); // so that we know what went wrong if the request failed
        toast("Wrong input!!  try again..");
      });
  };

  return (
    <Form>
      <FormGroup>
        <Label for="exampleEmail">Email</Label>
        <Input value={name} onChange={(q) => setname(q.target.value)} />
        <FormFeedback>You will not be able to see this</FormFeedback>
      </FormGroup>
      <FormGroup>
        <Label for="exampleEmail">password</Label>
        <Input
          type="password"
          value={pass}
          onChange={(e) => {
            setpass(e.target.value);
          }}
        />
        <FormFeedback tooltip>You will not be able to see this</FormFeedback>
        <FormText>forgot pass? Sorry i cant help</FormText>
      </FormGroup>
      <Button type="submit" onClick={verify}>
        Log in!!
      </Button>
    </Form>
  );
};

export default SignIn;
